<header class="mbs-card_header">
  @if (headerTemplate(); as template) {
    <ng-container [ngTemplateOutlet]="template" />
  } @else {
    @if (headerIco(); as icon) {
      <div class="mbs-card_ico">
        <span [ngClass]="[icon]"></span>
      </div>
    }
    <div class="mbs-card_title">
      {{ headerTitle() }}
    </div>
  }
</header>
